// Sélecteur de période comptable (année / trimestre / mois) — PARTAGÉ par le tableau de bord
// et l'écran « Recettes & achats » (27/10/2026). Extrait de src/pages/TableauBord.tsx sans
// changement de comportement : mêmes listes, mêmes valeurs par défaut (période en cours,
// 6 dernières années).
//
// usePeriode() porte l'état ; <ChampsPeriode> affiche les listes déroulantes. Les champs sont
// rendus SANS conteneur, pour que chaque écran les place dans sa propre barre de filtres.

import { useState } from 'react'
import { bornes, libellePeriode, MOIS, type PeriodeType } from '@/lib/periodes'

export interface EtatPeriode {
  type: PeriodeType
  setType: (t: PeriodeType) => void
  annee: number
  setAnnee: (a: number) => void
  trimestre: number
  setTrimestre: (t: number) => void
  mois: number
  setMois: (m: number) => void
  debut: string
  fin: string
  libelle: string
}

export function usePeriode(typeInitial: PeriodeType = 'annee'): EtatPeriode {
  const maintenant = new Date()
  const [type, setType] = useState<PeriodeType>(typeInitial)
  const [annee, setAnnee] = useState(maintenant.getFullYear())
  const [trimestre, setTrimestre] = useState(Math.floor(maintenant.getMonth() / 3) + 1)
  const [mois, setMois] = useState(maintenant.getMonth() + 1)
  const [debut, fin] = bornes(type, annee, trimestre, mois)
  return {
    type, setType, annee, setAnnee, trimestre, setTrimestre, mois, setMois,
    debut, fin, libelle: libellePeriode(type, annee, trimestre, mois),
  }
}

const champ =
  'w-full rounded-lg border border-stone-300 bg-white px-3 py-2 text-sm text-bdspInk focus:border-bdspIndigo focus:outline-none'
const label = 'mb-1 block text-xs font-medium text-stone-600'

export default function ChampsPeriode({ p }: { p: EtatPeriode }) {
  const annees = Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i)
  return (
    <>
      <div>
        <label className={label}>Période</label>
        <select className={champ} value={p.type} onChange={(e) => p.setType(e.target.value as PeriodeType)}>
          <option value="annee">Année</option>
          <option value="trimestre">Trimestre</option>
          <option value="mois">Mois</option>
        </select>
      </div>
      <div>
        <label className={label}>Année</label>
        <select className={champ} value={p.annee} onChange={(e) => p.setAnnee(Number(e.target.value))}>
          {annees.map((a) => (
            <option key={a} value={a}>{a}</option>
          ))}
        </select>
      </div>
      {p.type === 'trimestre' && (
        <div>
          <label className={label}>Trimestre</label>
          <select className={champ} value={p.trimestre} onChange={(e) => p.setTrimestre(Number(e.target.value))}>
            {[1, 2, 3, 4].map((t) => (
              <option key={t} value={t}>T{t}</option>
            ))}
          </select>
        </div>
      )}
      {p.type === 'mois' && (
        <div>
          <label className={label}>Mois</label>
          <select className={champ} value={p.mois} onChange={(e) => p.setMois(Number(e.target.value))}>
            {MOIS.map((m, i) => (
              <option key={m} value={i + 1}>{m}</option>
            ))}
          </select>
        </div>
      )}
    </>
  )
}
